import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withState from 'recompose/withState';
import withHandlers from 'recompose/withHandlers';
import lifecycle from 'recompose/lifecycle';
import { withFormik } from 'formik';
import {
  getAddressString,
  getTJHCountryOptions,
  isAddressFilled,
} from './helpers';
import {
  fetchBingLocations,
  getLocations,
  saveLatLng,
  isLatLngComplete,
} from './duck';
import { withModel } from '../../../data-providers/model';
import { connect } from 'react-redux';
import withValidationData from '../../../hocs/withValidationData';
import { validateCreationForm, onFieldChange } from '../helpers';
import HomeAddress from './HomeAddress';
import withMediaQueries from '../../../hocs/withMediaQueries';

const enhance = compose(
  withMediaQueries,
  withValidationData,
  connect(
    state => ({
      addresses: getLocations(state),
      isLatLngComplete: isLatLngComplete(state),
    }),
    dispatch => ({
      fetchBingLocations: (address, country) =>
        dispatch(fetchBingLocations(address, country)),
      saveLatLng: values => dispatch(saveLatLng(values)),
    }),
  ),
  withState('addressListIndex', 'setAddressListIndex', null),
  withFormik({
    mapPropsToValues: props => ({
      base: '',
      locale: props.productCustomisation.locale,
      door: props.queryParams.door || '',
      street: props.queryParams.street || '',
      city: props.queryParams.city || '',
      country: props.productCustomisation.country,
      postcode: '',
      lat: 'empty',
      lng: 'empty',
    }),
    validate: (values, props) => validateCreationForm(values, props),
    validateOnChange: false,
    handleSubmit: (values, formikBag) => {
      const props = formikBag.props;
      const location = props.addresses[props.addressListIndex];
      if (location) {
        props.saveLatLng({ lat: location.lat, lng: location.lng });
        values.lat = location.lat;
        values.lng = location.lng;
      }
      props.onFormikSubmit(values, false);
    },
  }),
  withState('addressString', 'setAddressString', props => getAddressString(props.values)),
  withHandlers({
    onChange: props => e => {
      onFieldChange(props)(e);
      const values = {
        ...props.values,
        [e.target.id]: e.target.value,
      };
      props.setAddressString(getAddressString(values));
    },
    handleAddressListChange: props => e =>
      props.setAddressListIndex(parseInt(e.target.value, 10)),
  }),
  withModel,
  withProps(props => ({
    isAddressFilled: isAddressFilled(props.values),
    countryOptions: getTJHCountryOptions(props.values.locale),
  })),
  lifecycle({
    componentDidUpdate(prevProps) {
      const props = this.props;
      if (
        prevProps.addressString !== props.addressString &&
        props.isAddressFilled
      ) {
        prevProps.fetchBingLocations(
          props.addressString,
          props.values.country,
        );
      }
    },
  }),
);

export default enhance(HomeAddress);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/HomeAddress/index.js